/**
 * SMB Component - FAQ and System Requirements
 * @copyright 2018 AVAST Software s.r.o.
 * @author Alex Ratman
 * @since 2018-09
 *
 * DESCRIPTION:
 * Functionality for FAQ and System Requirements
 */
 
$(document).ready(function() {
  
  // Open proper Comparison Table tab  
  $('.faq__item [data-platform]').on('click', function() {
    var platform = $(this).data('platform');

    $('.c-comparison-nav [data-platform="' + platform + '"]').trigger('click');
  });
        
});